import { render, staticRenderFns } from "./TypeNav.vue?vue&type=template&id=1cfb5768&scoped=true"
import script from "./TypeNav.vue?vue&type=script&lang=js"
export * from "./TypeNav.vue?vue&type=script&lang=js"
import style0 from "./TypeNav.vue?vue&type=style&index=0&id=1cfb5768&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cfb5768",
  null
  
)

export default component.exports